import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

interface FilterObject {
  airport: string;
  type: string;
  startDateDay: string;
  startDateMonth: string;
  startDateYear: string;
  endDateDay: string;
  endDateMonth: string;
  endDateYear: string;
  showPast: Boolean;
  showCancelled: Boolean;
}

@Component({
  selector: 'app-admin-filters',
  templateUrl: './admin-filters.component.html',
  styleUrls: ['./admin-filters.component.scss']
})
export class AdminFiltersComponent implements OnInit {
  
  @Input()
  appCopy;

  @Input()
  selectedLanguage;

  @Output()
  appliedFilters: EventEmitter<any> = new EventEmitter();

  @Input()
  filtersSelected;

  public filter: FilterObject = {
    airport: '',
    type: '',
    startDateDay: null,
    startDateMonth: null,
    startDateYear: null,
    endDateDay: null,
    endDateMonth: null,
    endDateYear: null,
    showPast: false,
    showCancelled: false
  };

  constructor() { }

  ngOnInit() {
    if (typeof this.filtersSelected !== 'undefined') {
      this.filter = this.filtersSelected;
    }
  }

  filterChanged(value) {
    this.appliedFilters.emit(this.filter);
  }

}
